<app-menu></app-menu>
<div class="desktop-download">
  <div class="page-shell">
    <header class="page-header">
      <div class="page-title">
        <p class="eyebrow">ControlChat Desktop</p>
        <h2>Download do aplicativo</h2>
        <p>Instale o ControlChat no seu computador e mantenha as conversas sempre acessíveis.</p>
      </div>
      <div class="page-meta">
        <div class="meta-card">
          <span class="meta-title">Status</span>
          <span class="meta-value">Versão 0.1.2</span>
        </div>
        <div class="meta-card">
          <span class="meta-title">Plataformas</span>
          <span class="meta-value">Windows · Mac</span>
        </div>
      </div>
    </header>

    <section class="page-grid">
      <div class="download-card">
        <div class="card-header">
          <h3>Baixar instalador</h3>
          <span class="pill">Recomendado</span>
        </div>
        <p>Escolha a plataforma desejada. O download fica registrado no sistema.</p>
        <div class="download-actions">
          <button class="download-btn" type="button" (click)="download('windows')">
            Download Windows
          </button>
          <button class="download-btn outline" type="button" (click)="download('mac')">
            Download Mac
          </button>
        </div>
        <small class="download-note">Ao baixar, o sistema registra o download.</small>
      </div>

      <div class="info-card">
        <h3>Como funciona</h3>
        <ul>
          <li>Instale o aplicativo no Windows ou Mac.</li>
          <li>Entre com seu usuário do ControlPS.</li>
          <li>As mensagens ficam sincronizadas em tempo real.</li>
          <li>Você pode usar em paralelo com o navegador.</li>
        </ul>
      </div>
    </section>
  </div>
</div>
